// extracted by mini-css-extract-plugin
export default {"remindersContainer":"Reminders_remindersContainer__reujC"};